import { render, staticRenderFns } from "./BeneficiaryBenefitDetails.vue?vue&type=template&id=27350a24&"
import script from "./benefit_details.js?vue&type=script&lang=js&"
export * from "./benefit_details.js?vue&type=script&lang=js&"
import style0 from "./BeneficiaryBenefitDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/styles/flexben_beneficiary.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports